<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="dwkqhglXqDialogVisible"
            width="60%"
            @close="closeDialogVisible">
            <el-table
                :data="dwkqhglXqData"
                style="width: 100%">
                <!-- <el-table-column
                    label="序号"
                    width="60" type="index" :index="indexMethod">
                </el-table-column> -->
                <el-table-column
                    prop="bmmc"
                    label="部门名称"
                    width="180">
                </el-table-column>
                <el-table-column
                    prop="username"
                    label="职员姓名">
                </el-table-column>
                <el-table-column
                    prop="dksj"
                    label="日期">
                </el-table-column>
                <el-table-column
                    prop="bclx"
                    label="班次类型">
                    <template slot-scope="scope">
                        <span v-if="scope.row.bclx === '1'">早班</span>
                        <span v-if="scope.row.bclx === '2'">中班</span>
                        <span v-if="scope.row.bclx === '3'">晚班</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="dwkqhglXqHandleSizeChange"
                @current-change="dwkqhglXqHandleCurrentChange"
                :current-page="dwkqhglXqCurrentNo"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="dwkqhglXqPageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dwkqhglXqPageTotal">
            </el-pagination>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dwkqhglXqDialogVisible = false">取 消</el-button>
                <!-- <el-button type="primary" @click="dwkqhglXqDialogVisible = false">确 定</el-button> -->
            </span>
        </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        title: '提示',
        type: 0,
        dwkqhglXqDialogVisible: false,
        dwkqhglXqData:[],
        dwkqhglXqCurrentNo: 1,
        dwkqhglXqPageSize: 10,
        dwkqhglXqPageTotal: 0,
        dwkqhglXqForm: {}
      }
    },
    methods: {
      init(val,type) {
          this.dwkqhglXqDialogVisible = true
          this.dwkqhglXqForm = val
          this.type = type
          this.dwkqhglXqCurrentNo = 1
          this.dwkqhglXqPageSize = 10
          this.dwkqhglXqPageTotal = 0
          if (type==1) {
            this.title = "迟到信息详情"
            this.getDwKqhglXqByCdcsAndZtcs(val,'2');
          } else if (type==2) {
            this.title = "早退信息详情"
            this.getDwKqhglXqByCdcsAndZtcs(val,'3');
          } else if (type==3) {
            this.title = "旷工信息详情"
            this.getDwKqhglXqByCdcsAndZtcs(val,'1');
          }
      },
      dwkqhglXqHandleSizeChange(val) {
        this.dwkqhglXqPageSize = val;
        if (this.type==1) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'2');
        } else if (this.type==2) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'3');
        } else if (this.type==3) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'1');
        }
      },
      dwkqhglXqHandleCurrentChange(val) {
        this.dwkqhglXqCurrentNo = val;
        if (this.type==1) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'2');
        } else if (this.type==2) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'3');
        } else if (this.type==3) {
            this.getDwKqhglXqByCdcsAndZtcs(this.dwkqhglXqForm,'1');
        }
      },
      getDwKqhglXqByCdcsAndZtcs(val,status) {
        this.$request({
            url: this.type == 1 || this.type == 2 ? '/bjba/ddkhgl/getDwKqhglXqByCdcsAndZtcs' : '/bjba/ddkhgl/getDwKqhglXqByKgcs',
            method: 'get',
            params: {
                page: this.dwkqhglXqCurrentNo,
                pagesize: this.dwkqhglXqPageSize,
                bmid: val.bmid,
                month: val.month,
                status: status
            }
        }).then(res => {
            console.log("获取到的队伍考勤合格率--详情数据为：",res)
            this.dwkqhglXqDialogVisible = true
            this.dwkqhglXqData = res.data.data.content
            this.dwkqhglXqPageTotal = res.data.data.totalElements
        }).catch(err => {
            console.log(err)
        })
      },
      closeDialogVisible() {
        this.dwkqhglXqCurrentNo = 1
      }
    }
  }
  </script>
  
  <style>
  .echart01 {
      font-size: 10px;
      font-weight: 700;
      width: 300px;
  }
  </style>
  